import { i as T } from "../../util-b2b0dc25.js";
function h(o, s) {
  if (T())
    return;
  if (!s) {
    o.scrollTop = 0;
    return;
  }
  const e = [];
  let t = s.offsetParent;
  for (; t && o !== t && o.contains(t); )
    e.push(t), t = t.offsetParent;
  const f = s.offsetTop + e.reduce((r, c) => r + c.offsetTop, 0), l = f + s.offsetHeight, i = o.scrollTop, p = i + o.clientHeight;
  f < i ? o.scrollTop = f : l > p && (o.scrollTop = l - o.clientHeight);
}
export {
  h as default
};
